export default __webpack_public_path__ + "static/media/pic13.c69d848e.jpg";